<script setup lang="ts">
const currentYear = new Date().getFullYear()
</script>

<template>
    <footer class="site-footer">
        <!-- 顶部红色横幅 -->
        <div class="footer-banner">
            <div class="banner-content">
                <p class="banner-text main-text">火锅、烤肉、海鲜、油炸、熟食、慕斯蛋糕一站式配齐</p>
                <p class="banner-text main-text">品类齐全 · 品质稳定 · 快捷高效 · 高性价比</p>
            </div>
        </div>

        <!-- 中部logo -->
        <div class="footer-main">
            <div class="brand-logo">
                <img src="@/assets/logoTow.png" alt="">
            </div>

            <div class="qr-wrapper">
                <img src="@/assets/qr.png" alt="官方微信" class="qr-img" />
            </div>
        </div>

        <!-- 底部版权 -->
        <div class="footer-copyright">
            <div class="copyright-line">
                Copyright {{ currentYear }} qianxizhenxuan.com All Rights Reserved
                <span class="divider">|</span>
                <a href="https://beian.miit.gov.cn/#/Integrated/index">豫ICP备2026011238号-1</a>
                <span class="divider">|</span>
                <a href="https://beian.mps.gov.cn/#/query/webSearch">豫公网安备41010802002556号</a>
            </div>
            <div class="company-name">河南千喜臻选商贸有限公司 版权所有</div>
        </div>
    </footer>
</template>

<style scoped lang="scss">
.site-footer {
    width: 100%;
    color: #FFFFFF;
    display: flex;
    flex-direction: column;
    background-color: #FFFFFF;
}

.footer-banner {
    position: relative;
    height: 424px;
    width: 100%;
    background-image: url('@/assets/footerS.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
    }

    .banner-content {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-top: 50px;
    }

    .banner-text {
        letter-spacing: 1px;
        line-height: 40px;

        &.main-text {
            font-size: 22px;
            margin-bottom: 8px;
            font-weight: 500;
        }

        &.sub-text {
            font-size: 14px;
            opacity: 0.9;
        }
    }
}

/* 中部内容 */
.footer-main {
    padding: 50px 0 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #2C2C2C;
    box-sizing: border-box;
}

.brand-logo {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    img {
        width: 244px;
        height: 70px;
    }

    .logo-icon {
        color: #d93a3a;
        font-size: 32px;
        font-weight: bold;
        font-family: Arial, sans-serif;
        margin-right: 8px;
    }

    .logo-text {
        font-size: 28px;
        font-weight: 500;
        letter-spacing: 2px;
    }
}

.qr-wrapper {
    width: 80%;
    padding: 8px;
    border-bottom: 1px solid #FFFFFF;
    display: flex;
    align-items: center;
    padding-bottom: 60px;
    justify-content: center;


    .qr-img {
        width: 100px;
        height: 100px;
        display: block;
    }
}

/* 底部版权 */
.footer-copyright {
    background-color: #2C2C2C;
    padding: 20px 0;
    text-align: center;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 1.8;

    a {
        text-decoration: none;
        color: #FFFFFF;
    }

    a:hover {
        color: #FE524B;
    }

    .divider {
        margin: 0 10px;
        color: #555;
    }

    .company-name {
        margin-top: 5px;
        opacity: 0.6;
    }
}
</style>